<script>
import IconMaterial from "@/assets/img/Sidebar/Icon material-dashboard.svg";
import IconStickyNote from "@/assets/img/Sidebar/Icon awesome-sticky-note.svg";
import HighlightOnIcon from "@/assets/img/highlight_on_icon.svg";
import ActivitiesOffIcon from "@/assets/img/activities_off_icon.svg";
import UserManagementOffIcon from "@/assets/img/user_management_off_icon.svg";
import SearchIcon from "@/assets/img/search_domain.svg"
import EllipseIcon from "@/assets/img/ellipse.svg"

const sidebarMenu = [
  { path: "/dashboard/highlights", img: HighlightOnIcon, title: "Highlights" },

  //Stock Opname
  // { path: '/dashboard/aktivitas-pengguna', img: IconMaterial, title: 'Aktivitas Pengguna' },

  {
    path: "/dashboard/activities",
    img: ActivitiesOffIcon,
    title: "Activities",
    children: [
      { path: "/dashboard/activities/activity-summary", img: EllipseIcon, title: "Activity Summary" },
      { path: "/dashboard/activities/latest-activity", img: EllipseIcon, title: "Latest Activity" },
      { path: "/dashboard/activities/customer-report", img: EllipseIcon, title: "Customer Report" },
      // { path: '/dashboard/activities/suspect-report', icon : 'fal fa-circle', title: 'Suspect Report' },
      { path: "/dashboard/activities/report-suspect", img: EllipseIcon, title: "Report Suspect" },
      { path: "/dashboard/activities/qr-code", img: EllipseIcon, title: "QR Code" },
    ],
  },

  {
    path: "/dashboard/domain-detection",
    img: SearchIcon,
    title: "Domain Detection",
    children: [
      { path: "/dashboard/domain-detection/summary", img: EllipseIcon, title: "Summary" },
      { path: "/dashboard/domain-detection/review-domain", img: EllipseIcon, title: "Review Domain" },
      { path: "/dashboard/domain-detection/domain-distribution", img: EllipseIcon, title: "Domain Distribution" },
    ],
  },

  { path: "/dashboard/user-management", img: UserManagementOffIcon, title: "User Management" },

  /* <i class="fal fa-qrcode"></i> */

  // { path: '/dashboard/qr-management', icon : 'fal fa-qrcode', title: 'QR Management' },
  // { path: '/dashboard/aktivitas-pengguna', icon : 'fal fa-qrcode', title: 'Aktivitas Pengguna' }
];

export default sidebarMenu;
</script>
